module.exports = __webpack_public_path__ + "img/mainpic.9789cc93.jpeg";